import * as React from 'react';

import ClockBadge16 from './ClockBadge16';

export const clockBadge16 = () => <ClockBadge16 />;

export default {
    title: 'Icon/Line/ClockBadge16',
    component: ClockBadge16,
    parameters: {
        notes: "`import ClockBadge16 from 'box-ui-elements/es/icon/line/ClockBadge16';`",
    },
};
